export enum Role {
  AdminViewer = 'ciamcom.admin.viewer',
  AdminOperator = 'ciamcom.admin.operator',
}
